import React from "react";
import { formatToDate } from "../../master/FormatToDateTime";

export default function FollowUps({ data }) {
  return (
    <div className="row g-3">
      {/* Summary Card */}
      <div className="col-12">
        <div className="card border-0 shadow-sm">
          <div className="card-header  d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="ri-phone-line me-2 text-primary"></i>
              Follow-up Details
            </h5>

            <button
              className="btn btn-primary btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#AddNewFollowup"
            >
              <i className="ri-add-line me-1"></i>
              Add Follow-up
            </button>
          </div>

          <div className="card-body">
            <div className="row">
              <div className="col-md-3">
                <small className="text-muted d-block">Reference</small>
                <div className="fw-semibold">
                  {data?.reference_detail || "-"}
                </div>
              </div>

              <div className="col-md-3">
                <small className="text-muted d-block">Counselor</small>
                <div className="fw-semibold">
                  {data?.counselor?.name || "-"}
                </div>
              </div>

              <div className="col-md-3">
                <small className="text-muted d-block">Last Follow-up</small>
                <div className="fw-semibold">
                  {formatToDate(data?.followup_date)}
                </div>
              </div>

              <div className="col-md-3">
                <small className="text-muted d-block">Next Follow-up</small>
                <div className="fw-semibold text-primary">
                  {formatToDate(data?.next_followup_date)}
                </div>
              </div>

              <div className="col-12 mt-3">
                <small className="text-muted d-block">Notes</small>
                <div>{data?.note || "-"}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* History */}
      <div className="col-12">
        <div className="card border-0 shadow-sm">
          <div className="card-header">
            <h6 className="mb-0">Follow-up History</h6>
          </div>

          <div className="card-body">
            {!data?.followups?.length ? (
              <div className="text-center py-5">
                <i
                  className="ri-history-line text-muted"
                  style={{ fontSize: "48px" }}
                ></i>

                <h6 className="mt-3">No Follow-up History</h6>

                <p className="text-muted mb-0">
                  Add the first follow-up to start tracking.
                </p>
              </div>
            ) : (
              <div className="timeline">
                {data.followups.map((item, index) => (
                  <div key={item.id} className="card border mb-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div>
                          <span className="badge bg-primary">
                            Follow-up #{index + 1}
                          </span>
                        </div>

                        <small className="text-muted">
                          {formatToDate(item.followup_date)}
                        </small>
                      </div>

                      <div className="mt-3">
                        <strong>Response</strong>

                        <p className="mb-2 mt-1">{item.response || "-"}</p>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <small className="text-muted d-block">
                            Counselor
                          </small>

                          <span>{item?.counselor?.name || "-"}</span>
                        </div>

                        <div className="col-md-6">
                          <small className="text-muted d-block">
                            Next Follow-up
                          </small>

                          <span className="fw-semibold text-primary">
                            {formatToDate(item.next_followup_date)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
